import React, {Component} from 'react';
import {Layout} from 'antd';

const { Content } = Layout;

class Home extends Component {
  render() {
    return(
      <Content style={{
          margin: '0 16px'
        }}>
        <div style={{
            padding: 24,
            background: '#fff',
            minHeight: 360
          }}>
          Top 10 Coins
        </div>
      </Content>);
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/containers/Home/Home.js